// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__JbCj0","inputSearch":"Search_inputSearch__UUwZb"};